import { ParameterConfigString } from '../../pipeline/parameter-config-string';
import { IViolation } from '../../base/annotation';
import { shellStringResources } from '../../../Resources/ShellStringResources';
import { sanitizeAndFormatString } from '../../../shared/utils/string.util';

export class ParameterConfigStringUtils {

    public static createParameterConfigurationValidator(allowNull: boolean = false): (_activity?: {}, configs?: ParameterConfigString[], violation?: IViolation) => IViolation[] | undefined {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (_activity?: {}, configs?: ParameterConfigString[], violation?: IViolation): IViolation[] | undefined => {
            if (!configs) {
                return undefined;
            }
            if (violation && violation.context) {
                // only validate in this violation's context
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const configIndex = (violation.context as any).index;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const isKey = (violation.context as any).field === 'name';

                if (configIndex < 0 || configIndex >= configs.length) {
                    // this could happen if a header row was deleted
                    return undefined;
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!(violation.context as any).duplicate) {
                    if (isKey) {
                        return !!(configs[configIndex].name) ? undefined : [violation];
                    } else {
                        return !!(configs[configIndex].value) ? undefined : [violation];
                    }
                } else {
                    const keySet = new Set<string>(configs.map((item) => item.name));
                    return (keySet.size === configs.length) ? undefined : [violation];
                }
            } else {
                const keySet = new Set<string>();
                const violations = new Array<IViolation>();
                configs.forEach((config, index) => {
                    if (keySet.has(config.name)) {
                        violations.push({
                            message: () => shellStringResources.ParameterConfiguration_Error_DuplicateName,
                            context: {
                                field: 'name',
                                index,
                                duplicate: true
                            }
                        });
                    }
                    keySet.add(config.name);
                    if (config.name == null || config.name === '') {
                        violations.push({
                            message: () => shellStringResources.Activity_Error_Configuration_InvalidName,
                            context: {
                                field: 'name',
                                index
                            }
                        });
                    }
                    if (!allowNull && (config.value == null || (config.value === '')) && ParameterConfigString.VALUE.templateValue(config) === undefined) {
                        violations.push({
                            message: () => sanitizeAndFormatString(shellStringResources.Activity_Error_Configuration_InvalidValue, config?.name || ''),
                            context: {
                                field: 'value',
                                index
                            }
                        });
                    }
                });
                return violations.length > 0 ? violations : undefined;
            }
        };
    }
}
